import React, { FC } from 'react';
import { Outlet } from 'react-router-dom';
import useLocale from '../../locale/useLocale';
import './Navigation.scss';

type AdminTabsProps = { children?: JSX.Element };

const AdminTabs: FC<AdminTabsProps> = ({ children }) => {
    const { l } = useLocale();

    return (
        <>
            <h1>{l('_adminPanelTitleCase')}</h1>
            {children || <Outlet />}
        </>
    );
};

export default AdminTabs;
